"use client";

import { Suspense } from "react";

import { LoadingLayout } from "@/components/layouts/loading-layout";

export function SuspenseBoundary({ children }: { children: React.ReactNode }) {
  return <Suspense fallback={<LoadingLayout />}>{children}</Suspense>;
}
